// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"664cdd27","165":"38b9193b","213":"5672bb7d","239":"8764e541","453":"b9759f2e","455":"0e260425","796":"a37c7149","806":"0ad8bf68"}[chunkId] + ".chunk.js";
};